export enum TileStatus {
  COMING_SOON,
  LOADING,
  LOADED,
  LOADED_NO_DATA,
  LOAD_ERROR
}